import { format, parseISO } from 'date-fns';
import de from 'date-fns/locale/de';
import en from 'date-fns/locale/en-US';
import es from 'date-fns/locale/es';
import fr from 'date-fns/locale/fr';
import it from 'date-fns/locale/it';
import { registerLocale, setDefaultLocale } from 'react-datepicker';

import moment from 'moment-timezone';
import 'moment/locale/fr';
import 'moment/locale/de';
import 'moment/locale/es';
import 'moment/locale/it';

moment.locale(window.__DATA__?.lang || 'fr');
const { eventTimezone, forceForEveryone } = window.__DATA__?.options?.timezone || {};

const forcedTimezone = window.__DATA__?.design?.forceTimezone || (forceForEveryone && eventTimezone);

export const momentTz = forcedTimezone
  ? (date: moment.MomentInput, formatSpec: moment.MomentFormatSpecification = moment.ISO_8601) => moment(date, formatSpec).tz(forcedTimezone)
  : moment;

export function forceTimezone() {
  return !!forcedTimezone;
}

type Locales = Record<string, any>;

export const locales: Locales = { fr, en, es, de, it };

export function dateFNSLocale() {
  return locales[(window.__DATA__ || {}).lang] || fr;
}

// Init react-datepicker
Object.entries(locales).forEach(([locale, strings]) => registerLocale(locale, strings));
setDefaultLocale(dateFNSLocale());

export function ensureDate(date: string | number | Date) {
  if (typeof date === 'string') return parseISO(date);
  return new Date(date);
}

export function localeFormat(date: string | number | Date, dateFormat: string) {
  if (!date) return '';
  return format(ensureDate(date), dateFormat, { locale: dateFNSLocale() });
}

export function getTimeZone() {
  if (Intl && Intl.DateTimeFormat && Intl.DateTimeFormat().resolvedOptions) {
    return Intl.DateTimeFormat().resolvedOptions();
  }
  return undefined;
}
